import React, { FC, Fragment, useMemo } from "react"
import { EventResponse } from "@jnext/ts-axios-eventformat"
import { JCMSStaticCardProps } from "../../../JCMSStaticSections/components"
import { rewardsToJBadgeItem } from "../../../lib"
import { Card } from "antd"
import { JHTML } from "../../../JHTML"
import { useTranslation } from "react-i18next"
import { JBadgeListProps } from "../../../JBadgeList"

import './../../JCMSCard.scss'
import './JCardEventCompleted.scss'
import {useJCommonContext} from "../../../JCommonProvider";
import StarCheck from "../../../JIcons/starcheck";

export interface JCardEventCompletedProps extends EventResponse {
    cardProps?: JCMSStaticCardProps
}

export const JCardEventCompleted: FC<JCardEventCompletedProps> = ({ cardProps, ...event }) => {
    const { t: translate } = useTranslation();
    const title = useMemo(() => event.cmsConfig?.title || '', [event]);
    const earnedPoints: JBadgeListProps['items'] = useMemo(() => rewardsToJBadgeItem(event.rewards), [event]);
    const {getImageURL} = useJCommonContext();
    return (
        <div className={'jcms-card-event-template jcms-card-event-completed'}>
            <div className={'jcms-card'}>
                <Card
                    onClick={console.log}
                >
                    <Card.Meta
                        title={
                            <Fragment>
                                <div className="space-between event-template-title-header-content">
                                    <span>{translate('EVENT_COMPLETED_HEADER_LABEL')}</span>
                                    <StarCheck size={25} />
                                </div>
                                <JHTML.Text html={title} />
                            </Fragment>

                        }
                        description={
                            <Fragment>
                                <div className="earned-points">
                                    <div className="earned-points-title">
                                        {translate('EVENT_COMPLETED_EARNED_POINTS')}
                                    </div>
                                    {
                                        earnedPoints.map((item, i) => (
                                            <div className="space-between" key={i}>
                                                <span>
                                                    {item.title}
                                                </span>
                                                <span className="event-completed-badge">
                                                    +{item.value}
                                                    {
                                                        item.imageRef ? (
                                                            <img aria-hidden={true} src={getImageURL(item.imageRef)} />
                                                        ) : (
                                                            <div className="img-placeholder"></div>
                                                        )
                                                    }
                                                </span>
                                            </div>
                                        ))
                                    }

                                </div>
                            </Fragment>
                        }
                    />
                </Card>
            </div>

        </div>
    )
}
